import React, {createRef} from "react"
import {findDOMNode} from "react-dom"

import Breadcrumbs from '../../../../core/gd-components/breadcrumbs/breadcrumbs'
import FinderTask from '../items/task/finder-task'
import FinderProject from '../items/project/finder-project'
import VScroll from "../../scrolling/custom-v-scroll/v-scroll"
import FinderTasksCollection from "../../../model2/task/finder/collection"
import FinderTaskModel from "../../../model2/task/finder/finder-task-model"
import {SpaceProto} from "../../../model2/space/space-proto"
import Workspace from "../../../model2/space/workspaces/workspace"

type Props = {
    companyId?      : ID
    selectedTaskId? : ID
    parentProjectId?: ID | null

    search?         : string
    data            : FinderTasksCollection | null

    isSearching?    : boolean
    noSubtasks?     : boolean
    showRecent?     : boolean

    onClickCompany? : func
    onClickProject? : func
    onClickTask?    : func
    onTab?          : {():void}
}

type State = {
    currentCursorKey: any
}

const debug = false
// const debug = "TaskFinderMain"

export default class TaskFinderMain extends React.Component<Props, State> {

    private scrollRef: any          = createRef()
    private selectedItemRef: any    = createRef()

    private optionsLength: number   = 0

    constructor(props: Props) {
        super(props)

        debug && console.log(debug, 'constructor', this.props.data)

        this.state = {
            currentCursorKey: 0
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
        debug && console.log(debug, 'componentDidUpdate', this.state.currentCursorKey)

        if (this.scrollRef.current) {
            const node: any = findDOMNode(this.selectedItemRef.current)
            if (node) {
                this.scrollRef.current?.setScrollTop(node.offsetTop + node.clientHeight/2,true,250)
            }
        }
    }

    onKeyDown = (event: any) => {
        debug && console.log(debug, 'onKeyDown', this.state.currentCursorKey, event)

        let newValue
        switch(event.code){
            case 'Tab':
                event.preventDefault()
                this.props.onTab && this.props.onTab()
                break

            case 'ArrowUp':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'ArrowDown':
                if (_.isNil(this.state.currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = this.state.currentCursorKey + 1
                    if (newValue > this.optionsLength - 1) newValue = this.optionsLength - 1;
                }

                this.setState({
                    currentCursorKey: newValue
                })
                break

            case 'Enter':
                event.preventDefault()
                event.stopPropagation()

                if (this.selectedItemRef.current) this.selectedItemRef.current.click()
                break
        }
    }

    renderItems() {
        if (this.props.isSearching) {
            return <div className="searching-label">Searching tasks...</div>
        } else {
            let res: any[] = [], filteredProjects = [], baseKey = 0
            let projects

            switch (this.props.parentProjectId) {
                case null:
                    const spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

                    _.map(spaces, (space: SpaceProto, key: number)=>{
                        const isSelected = key === this.state.currentCursorKey

                        if (space instanceof Workspace) {
                            res.push(<FinderProject ref             = {isSelected ? this.selectedItemRef : null}
                                                    key             = {space.id}
                                                    isHighlighted   = {isSelected}
                                                    project         = {space.project}
                                                    onClickProject  = {this.props.onClickProject}/>)
                        } else {
                            res.push(<FinderProject ref             = {isSelected ? this.selectedItemRef : null}
                                                    key             = {gd.spaces.projects.id}
                                                    isHighlighted   = {isSelected}
                                                    project         = {gd.spaces.projects.project}
                                                    onClickProject  = {()=>{this.props.onClickProject?.('projects')}}/>)
                        }
                    })
                    baseKey = filteredProjects.length
                    break

                case 'projects':
                    projects = _.filter(gd.spaces.projects.rootProjects, p=>{
                        return !p.isTag && !p.isView && !p.isLink
                    })
                    break

                default:
                    projects = _.filter(gd.session.projects.get(this.props.parentProjectId)?.treeChildren, p=>{
                        return !p.isTag && !p.isView && !p.isLink
                    })
            }

            if (!this.props.search && !this.props.showRecent) {
                filteredProjects    = _.orderBy(projects, p=>{
                    return p.name.toLowerCase()
                })

                _.map(filteredProjects, (p,key)=>{
                    const isSelected = key === this.state.currentCursorKey
                    res.push(<FinderProject ref             = {isSelected ? this.selectedItemRef : null}
                                            key             = {p.id}
                                            isHighlighted   = {isSelected}
                                            project         = {p}
                                            onClickProject  = {this.props.onClickProject}/>)
                })
                baseKey = filteredProjects.length
            }

            if (this.props.data) {
                const filteredTasks = _.orderBy(this.props.data.rootModels, (task: FinderTaskModel)=>task.sortPosition)
                _.map(filteredTasks, (task,key)=>{
                    const itemKey = baseKey + key
                    const isSelected = itemKey === this.state.currentCursorKey
                    res.push(<FinderTask ref                = {isSelected ? this.selectedItemRef : null}
                                         key                = {task.id}
                                         isHighlighted      = {isSelected}
                                         task               = {task}
                                         noSubtasks         = {this.props.noSubtasks}
                                         onClickTask        = {this.props.onClickTask}
                                         showParentProject  = {!!this.props.search}
                                         selected           = {this.props.selectedTaskId === task.id}/>)
                })
            }

            const tasksLength = this.props.data ? this.props.data.length : 0
            if (!this.props.search && !this.props.showRecent) {
                this.optionsLength = filteredProjects.length + tasksLength
            } else {
                this.optionsLength = tasksLength
            }

            return <div className="search-items">{res}</div>
        }
    }

    renderNotification() {
        const projects      = _.filter(gd.session.projects.treeRoots, p=>p.parentId === this.props.parentProjectId);
        const showNoTasks   = projects.length <= 0 && !!this.props.parentProjectId && !!this.props.data && this.props.data.length === 0 && !this.props.search;
        const noMatches     = !!this.props.data && this.props.data.length === 0 && !!this.props.search && !this.props.isSearching;
        const showLoading   = !this.props.data && !this.props.search && !this.props.isSearching;

        let label = null;
        if (showNoTasks) label = <div className="not-found">No tasks found</div>;
        else if (noMatches) label = <div className="not-found">No tasks found</div>;
        else if (showLoading) label = <div className="not-found">Loading...</div>;

        return label;
    }

    render() {
        return (
            <div ref="main" className="finder-main">
                <VScroll ref            = {this.scrollRef}
                         containerClass = "finder-main-container"
                         minDragHeight  = {20}>
                    {!this.props.search && this.props.parentProjectId && !this.props.showRecent &&
                        <Breadcrumbs className                      = "finder-breadcrumbs"
                                     companyId                      = {this.props.companyId}
                                     projectId                      = {null}
                                     currentProject                 = {this.props.parentProjectId}
                                     currentProjectAsLastBreadcrumb = {true}
                                     onNavigateCompany              = {this.props.onClickCompany}
                                     onNavigateProject              = {this.props.onClickProject}/>}

                    {!this.props.search && this.props.parentProjectId &&
                        <div className="horizontal-separator"/>}

                    {this.renderItems()}
                    {this.renderNotification()}
                </VScroll>
            </div>
        );
    }
}